// Copyright ©️ 2026 eVolve MEP, LLC

import { useState } from 'react';

import { useLocation } from 'react-router';

import { moduleRoute, type NavRouteOption } from 'app/Layout/NavBar/globalNavigationMenu';

const FABRICATION_PATH = `/${moduleRoute}${'/fabrication' satisfies NavRouteOption['route']}`;

/**
 * Whether the nav shows the Fabrication sub nav. It is pushed on any Fabrication route; `pop` returns to the
 * main nav without leaving the page, until the next navigation or `push`.
 */
export const useFabricationSubNav = () => {
  const { pathname } = useLocation();
  const [popped, setPopped] = useState(false);
  const [previousPathname, setPreviousPathname] = useState(pathname);
  if (pathname !== previousPathname) {
    setPreviousPathname(pathname);
    setPopped(false);
  }

  const onFabricationRoute = pathname === FABRICATION_PATH || pathname.startsWith(`${FABRICATION_PATH}/`);
  return {
    pushed: onFabricationRoute && !popped,
    push: () => setPopped(false),
    pop: () => setPopped(true),
  };
};
